import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

/** Насильно переопределяем gwc'шную высоту, тк очень криво сделаны отступы в мультилайн режиме */
export const multiline = css`
  & > div {
    padding-block: ${spacing(1)};
    min-block-size: auto;
  }
`
